<template>
  <v-card
    v-if="configPcd && configPcd.indicar_pcd"
    flat
    class="rounded-xl mt-4 mb-6 overflow-hidden transition-swing"
    style="background: linear-gradient(135deg, #E8EAF6 0%, #E3F2FD 100%); border: 1px solid #C5CAE9;"
  >
    <v-card-text class="pa-6">
      <v-row align="center">
        <v-col cols="12" sm="auto" class="text-center text-sm-left">
          <v-avatar size="80" color="white" style="box-shadow: 0 4px 12px rgba(63, 81, 181, 0.1);">
            <v-icon size="40" color="#3F51B5">mdi-human-wheelchair</v-icon>
          </v-avatar>
        </v-col>

        <v-col cols="12" sm="" class="text-center text-sm-left">
          <div class="caption text-uppercase font-weight-bold mb-1" style="color: #5C6BC0; letter-spacing: 1px;">
            Programa de Inclusão
          </div>
          
          <div class="text-h6 font-weight-black mb-4" style="color: #1A237E; line-height: 1.2;">
            {{ configPcd.texto_pcd }}
          </div>

          <div class="d-flex flex-column flex-sm-row align-center justify-center justify-sm-start">
            <v-btn
              rounded
              color="#3F51B5"
              dark
              elevation="0"
              to="/indicar-pcd"
              class="px-8 font-weight-bold mb-3 mb-sm-0 mr-sm-4"
              style="letter-spacing: 0.5px;"
            >
              Indicar Agora
            </v-btn>

            <v-dialog v-model="dialog" max-width="750" scrollable>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  rounded
                  color="#3F51B5"
                  v-on="on"
                  v-bind="attrs"
                  class="font-weight-bold px-4"
                >
                  Mais informações
                </v-btn>
              </template>
              
              <orientacoes-indicacao-pcd>
                <v-spacer></v-spacer>
                <v-btn 
                  text 
                  @click="dialog = false" 
                  color="#3F51B5" 
                  class="font-weight-bold" 
                  rounded
                >
                  Fechar
                </v-btn>
              </orientacoes-indicacao-pcd>
            </v-dialog>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import OrientacoesIndicacaoPcd from "./OrientacoesIndicacaoPcd.vue";

export default {
  components: { OrientacoesIndicacaoPcd },
  computed: {
    ...mapState("pcd", ["configPcd"])
  },
  data: () => ({
    dialog: false,
  }),
};
</script>

<style scoped>
/* O estilo scoped garante que não vaze para outras páginas caso adicione CSS no futuro */
</style>